module.exports = __webpack_public_path__ + "static/specificity2-b1ef8bcc7e02813b55653365d042b262.png";